import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Box, MenuItem } from "@mui/material";

import AllowedFeaturesToolTip from "../../../AllowedFeaturesToolTip";
import { STATUS_COLORS_OPACITY } from "../../../../../../constants";

const TableBody: React.FC = () => {
  const { data } = useSelector((state) => state.agents);

  return (
    <tbody>
      {data.agents.map((agent) => {
        return (
          <Box
            component="tr"
            sx={{
              ...(agent.active && { backgroundColor: STATUS_COLORS_OPACITY.lightGreen }),
              ...(!agent.active && { backgroundColor: STATUS_COLORS_OPACITY.lightRed }),
            }}
            key={agent.id}
          >
            <td>{agent.id}</td>
            <td>
              <MenuItem component={Link} to={`/agent/${agent.id}`}>
                {agent.name}
              </MenuItem>
            </td>
            <td>{agent.email}</td>
            <td>{agent.admin_accounts_policies_preset.name_preset}</td>
            <td>
              {data.agentsWithCustomPreset[agent.id] && (
                <AllowedFeaturesToolTip
                  allowed_features={Array.from(new Set(data.agentsWithCustomPreset[agent.id]))}
                />
              )}
            </td>
            <td>{agent.active ? "Active" : "Inactive"}</td>
          </Box>
        );
      })}
    </tbody>
  );
};

export default TableBody;
